import { css } from 'styled-components'

export const DanglingLeft = css`
  @keyframes danglingLeft {
    from {
      transform: rotate(0);
      transform-origin: top;
    }
    30% {
      transform: rotate(10deg);
      transform-origin: top;
    }
    60% {
      transform: rotate(-7deg);
      transform-origin: top;
    }
    80% {
      transform: rotate(4deg);
      transform-origin: top;
    }
    95% {
      transform: rotate(-1deg);
      transform-origin: top;
    }
    100% {
      transform: rotate(0);
      transform-origin: top;
    }
  }
`

export const DanglingRight = css`
  @keyframes danglingRight {
    from {
      transform: rotate(0);
      transform-origin: top;
    }
    30% {
      transform: rotate(-10deg);
      transform-origin: top;
    }
    60% {
      transform: rotate(7deg);
      transform-origin: top;
    }
    80% {
      transform: rotate(-4deg);
      transform-origin: top;
    }
    95% {
      transform: rotate(1deg);
      transform-origin: top;
    }
    100% {
      transform: rotate(0);
      transform-origin: top;
    }
  }
`

export const FadeIn = css`
  @keyframes fadeIn {
    from {
      visibility: hidden;
      opacity: 0;
    }
    to {
      visibility: visible;
      opacity: 1;
    }
  }
`

export const Squeeze = css`
  @keyframes sqeeze {
    from {
      transform: scaleX(1) scaleY(1);
    }
    25% {
      transform: scaleX(1.1) scaleY(0.9);
    }
    75% {
      transform: scaleX(0.9) scaleY(1.1);
    }
    100% {
      transform: scaleX(1) scaleY(1);
    }
  }
`

export const ZoomIn = css`
  @keyframes zoomIn {
    from {
      transform: scale(0);
    }
    60% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
`
